import React, { useEffect } from 'react'

import Link from "next/link";

import styles from './Venue.module.css'

const VenueList = (props) => {

  return (
    <section className={styles.venue_list_container +' fixed-nav'}>
      <img
        src={"/assets/images/result_map.svg"}
        alt="map-imag"
        className={styles.result_map}
      />
      <img
        src={"/assets/images/result_design.svg"}
        alt="map-imag-deisgn"
        className={styles.result_design}
      />


      <div className={styles.container_fluid}>
        { (
          <>
            <div className={styles.venue_list_header}>
              <h4 className={`text-center mb-4 ${styles.venue_list_heading}`}>
                {Array.isArray(props.cities) && props.cities.length ? "Recent Venues" : "Sorry, Venues are not available!"}
              </h4>
              {/* <p className={`text-center ${styles.venue_list_para}`}>
                Here are the venues
              </p>

              <p className={`text-center ${styles.venue_list_msg}`}>
                Includes all estimated travel expenses such as hotel, airfare,
                etc.
              </p> */}
            </div>
            <div className={styles.venue_list_section}>
              <ul
                className={`d-flex align-items-center justify-content-center flex-wrap ${styles.venue_list_cards}`}
              >
                {
                  props.cities?.map((city, index) => (
                    <Link key={index}  href={"/cities/"+ city.slug}>
                      <a className={styles.venue_card}>
                        <li>
                          <img className={styles.venue_thumbnail} src={process.env.IMAGE_LINK + city.thumbnail} alt="venue-image" />
                          <div className={styles.venue_card_detail_container}>
                            <h3>{city.name ?? ""}</h3>
                            <div>
                              <p>{city.shortDescription ?? ""}</p>
                            </div>
                          </div>
                          <div className={styles.venue_card_btn_container}>
                              <span className={styles.venue_card_btn_text}>Explore</span>
                          </div>
                        </li>
                      </a>
                    </Link>
                  ))
                }
                {/* <li className={styles.venue_card}>
                  <img src={'https://starlightprod-images.s3.amazonaws.com/Hudson%20House%20-%20venue%20details_1711577735969.jpg'} alt="venue-image" />
                  <div className={styles.venue_card_detail_container}>
                    <h3>Hudson House</h3>
                    <div>
                      <p>NYC Skyline Views</p>
                    </div>
                  </div>
                  <div className={styles.venue_card_btn_container}>
                    <button
                      className={`d-inline-flex align-items-center justify-content-center img_btn
                        ${styles.top_cities_main_slide_icon}`}
                    >
                      <img
                        src="/assets/images/flight_icon.svg"
                        alt="flight_icon"
                        width={50}
                        height={69}
                      />
                      <figcaption>GO</figcaption>
                    </button>
                  </div>
                </li>
                <li className={styles.venue_card}>
                  <img src={'https://starlightprod-images.s3.amazonaws.com/Thumbnail%20for%20Oheka_1711580481183.jpg'} alt="venue-image" />
                  <div className={styles.venue_card_detail_container}>
                    <h3>Oheka Castle</h3>
                    <div>
                      <p>Hilltop Mansion overlooking the Hudson River</p>
                    </div>
                  </div>
                  <div className={styles.venue_card_btn_container}>
                    <button
                      className={`d-inline-flex align-items-center justify-content-center img_btn
                        ${styles.top_cities_main_slide_icon}`}
                    >
                      <img
                        src="/assets/images/flight_icon.svg"
                        alt="flight_icon"
                        width={50}
                        height={69}
                      />
                      <figcaption>GO</figcaption>
                    </button>
                  </div>
                </li> */}
              </ul>
            </div>
          </>
        )}
      </div>
    </section>
  )
}

export default VenueList

